import React from 'react';
import GenericMenu from './source/GenericMenuProject';
import { ESTIMATE_MENU, ESTIMATE_SECTIONS } from './constants/menuStructureProject';

export default function EstimateMenu(props) {
  return (
    <GenericMenu 
      menuConfig={ESTIMATE_MENU} 
      sectionsMap={ESTIMATE_SECTIONS} 
      propsRouter={props} 
    />
  );
}